/* christina-onsite-cro.js — program konwersyjny (CRO onsite)
 * R8 (2026-08-05). Logika przeniesiona 1:1 z inline <script> w
 * snippets/christina-onsite-cro.liquid (21 734 B w KAŻDYM dokumencie).
 * W dokumencie zostaje wyłącznie konfiguracja JSON; ten plik idzie `defer`.
 *
 * ZMIANY MERYTORYCZNE W R8 (dwie, obie w sekcji „P0"):
 *
 *  P0-1  KOLIZJA Z MODALAMI ZAKUPOWYMI — realna blokada sprzedaży.
 *        Stan zastany: `.cco-ov { z-index: 1000000 }`. Quick view na karcie
 *        produktu ma z-index 40, koszyk 35, szuflada menu 30 — nakładka popupu
 *        stała nad nimi wszystkimi i na 390×844 przykrywała przycisk
 *        „Dodaj do koszyka" w quick view. Naprawa jest dwuwarstwowa:
 *          (a) warstwa: --cco-z: 28 (patrz christina-onsite-cro.css),
 *          (b) zachowanie: popup NIE POWSTAJE, gdy otwarty jest quick view,
 *              koszyk, szuflada menu, wyszukiwarka albo panel Advisora,
 *              a jeśli którykolwiek z nich otworzy się przy ŻYWYM popupie —
 *              popup natychmiast ustępuje (atrybut data-cco-yield zdejmuje
 *              pointer-events i widoczność) i zamyka się.
 *        Wykrywanie nakładek nie opiera się na nazwie atrybutu (`open`,
 *        `hidden`, `aria-expanded` — motyw używa ich niespójnie), tylko na
 *        stanie renderu: element jest „aktywny", gdy ma pudełko na ekranie
 *        i JEDNOCZEŚNIE nie jest wyłączony z interakcji (pointer-events,
 *        visibility). Zamknięta szuflada motywu ma klasę `pointer-events-none`,
 *        więc test jest odporny na zmiany w motywie.
 *
 *  P0-2  KONIEC NASŁUCHU `scroll`. Próg „90 % przewinięcia" liczy teraz
 *        IntersectionObserver na wartowniku wstawionym na końcu treści.
 *        Dolny rootMargin = 10 % wysokości dokumentu, więc wartownik wchodzi
 *        w pole obserwacji dokładnie wtedy, gdy dół okna jest w ostatnich
 *        10 % dokumentu — czyli przy tym samym progu co poprzednio, ale bez
 *        ani jednego odczytu układu na wątku głównym podczas przewijania.
 *
 * BEZ ZMIAN: wyzwalacz mouseout górną krawędzią (tylko wskaźnik precyzyjny),
 *   45 s bezczynności, cap 7 dni (localStorage `cco_pop_seen`), Klaviyo
 *   (VX5mFE, double opt-in), dataLayer `cca_*`, dialog modalny z pułapką
 *   fokusu, i18n PL/EN/zh-TW, ZERO manipulacji historią przeglądarki.
 */
(function () {
  "use strict";
  var CFG;
  try { CFG = JSON.parse(document.getElementById('cco-config').textContent); } catch (e) { return; }
  var I18N;
  try { I18N = JSON.parse(document.getElementById('cco-i18n').textContent); } catch (e) { I18N = {}; }
  function T(k) { return I18N[k] || ''; }
  var DAY = 86400000;
  function dl(ev, p) { window.dataLayer = window.dataLayer || []; var o = { event: ev }; if (p) { for (var k in p) o[k] = p[k]; } window.dataLayer.push(o); }
  function ls(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lset(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function zl(c) { return (c / 100).toFixed(2).replace('.', ',') + T('currencySuffix'); }
  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }

  /* ================================================================
     P0-1 — NAKŁADKI ZAKUPOWE. Popup ma im ustępować, nie konkurować.
     ================================================================ */
  var BLOCKERS = [
    'quick-view',            /* karta produktu -> podgląd z „Dodaj do koszyka" */
    '#CbQuickView',
    'cart-drawer', '#CartDrawer',
    'menu-drawer', '#MenuDrawer',
    'search-drawer', '#SearchDrawer',
    '.cca-panel',            /* panel AI Beauty Advisor */
    '.cb-qv-backdrop',       /* tło quick view z pakietu SimGym */
    'dialog[open]'
  ];

  function isActiveOverlay(el) {
    if (!el) return false;
    if (el.hasAttribute && el.hasAttribute('hidden')) return false;
    if (!el.getClientRects || !el.getClientRects().length) return false;
    var cs;
    try { cs = getComputedStyle(el); } catch (e) { return false; }
    if (!cs) return false;
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    /* Zamknięta szuflada motywu zostaje w DOM z `pointer-events:none`. */
    if (cs.pointerEvents === 'none') return false;
    return true;
  }

  function blockersOpen() {
    for (var i = 0; i < BLOCKERS.length; i++) {
      var list = document.querySelectorAll(BLOCKERS[i]);
      for (var j = 0; j < list.length; j++) {
        if (list[j].closest && list[j].closest('.cco-ov')) continue;
        if (isActiveOverlay(list[j])) return true;
      }
    }
    return false;
  }

  /* Popup żywy w chwili otwarcia nakładki zakupowej — ustąp i zamknij. */
  var activeYield = null;
  var blockerObs = null;
  /* T-MOD6 (2026-10-31): obserwator dziala tylko gdy popup jest otwarty (start przy activeYield, stop przy zamknieciu). */
  function stopBlockers() { if (blockerObs) { blockerObs.disconnect(); blockerObs = null; } }
  function watchBlockers() {
    if (!window.MutationObserver || blockerObs) return;
    var timer = null;
    function check() {
      timer = null;
      if (!activeYield) return;
      if (blockersOpen()) { var f = activeYield; activeYield = null; stopBlockers(); try { f(); } catch (e) {} }
    }
    blockerObs = new MutationObserver(function () {
      if (!activeYield || timer) return;
      timer = setTimeout(check, 60);
    });
    blockerObs.observe(document.documentElement, {
      attributes: true, subtree: true, childList: true,
      attributeFilter: ['open', 'hidden', 'class', 'style', 'aria-expanded']
    });
  }

  /* ---------- live cart state ---------- */
  var cart = { total: CFG.cartTotal || 0, count: CFG.cartCount || 0, firstProduct: CFG.firstProductId || null };
  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      cart.total = c.total_price; cart.count = c.item_count;
      cart.firstProduct = (c.items && c.items[0]) ? c.items[0].product_id : null;
      return c;
    }).catch(function () {});
  }
  /* T-MOD6: stan koszyka przy powrocie do karty potrzebny tylko na /cart. */
  if (CFG.pageType === 'cart') window.addEventListener('focus', function () { refreshCart(); });

  /* ---------- W2 cart enhancements (TYLKO strona /cart) ---------- */
  function cartEnhance(root) {
    /* T-VF3-UPSELL (2026-10-31) POZYCJE KOSZYKA PIERWSZE
       Diagnoza: blok stal przed formularzem, na 320 px pozycje zaczynaly sie 989 px nizej, a zmiana ilosci kasowala blok razem z trescia main-cart.
       Naprawa: blok idzie pod pozycje i pod "Twoj rytual", a po cart:updated wraca. */
    if (!root || root.querySelector('.cco-cart') || !root.querySelector('.cart-item')) return;
    var anchor = root.querySelector('#cart, form[action^="/cart"], .cart__items, [class*="cart-items"], .cart__footer');
    var host = root.querySelector('#MainContent') || root;
    var block = document.createElement('div'); block.className = 'cco-cart';
    block.innerHTML = '<div class="cco-trust"><span>' + T('trust1') + '</span><span>' + T('trust2') + '</span><span>' + T('trust3') + '</span><span>' + T('trust4') + '</span></div>'
      + '<div class="cco-xsell" hidden><p class="cco-xsell__h">' + T('xsellH') + '</p><div class="cco-xsell__row"></div></div>';
    var target = anchor || host;
    if (target === anchor && anchor.parentNode) {
      var after = anchor.parentNode.querySelector(':scope > .cb-bundle-progress') || anchor;
      anchor.parentNode.insertBefore(block, after.nextSibling);
    }
    else { target.insertBefore(block, target.firstChild); }
    loadXsell(block.querySelector('.cco-xsell'));
  }
  function fetchRecs(intent) {
    return fetch('/recommendations/products.json?product_id=' + cart.firstProduct + '&limit=4&intent=' + intent, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (d) { return (d && d.products) ? d.products : []; }).catch(function () { return []; });
  }
  function loadXsell(wrap) {
    if (!wrap || !cart.firstProduct) return;
    fetchRecs('complementary').then(function (ps) {
      if (ps && ps.length) return ps;
      return fetchRecs('related');
    }).then(function (ps) {
      ps = ps || []; if (!ps.length) return;
      var row = wrap.querySelector('.cco-xsell__row'); var html = '';
      ps.slice(0, 4).forEach(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0]; if (!v) return;
        var img = p.featured_image || (p.images && p.images[0]) || '';
        html += '<div class="cco-xc"><a href="' + esc(p.url) + '" class="cco-xc__add-link" tabindex="-1" aria-hidden="true"><img loading="lazy" src="' + esc(img) + '" alt=""></a>'
          + '<a href="' + esc(p.url) + '" class="cco-xc__t">' + esc(p.title) + '</a>'
          + '<span class="cco-xc__pr">' + zl(v.price) + '</span>'
          + '<button type="button" class="cco-xc__add" data-vid="' + v.id + '" data-t="' + esc(p.title) + '">' + T('add') + '</button></div>';
      });
      if (!html) return;
      row.innerHTML = html; wrap.hidden = false;
      row.querySelectorAll('.cco-xc__add').forEach(function (b) {
        b.addEventListener('click', function () {
          var vid = b.getAttribute('data-vid'); b.disabled = true; b.textContent = T('adding');
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: +vid, quantity: 1 }) })
            .then(function (r) { return r.json(); }).then(function () {
              dl('cca_recommendation_click', { cca_source: 'cart_xsell', product_id: vid, cta_label: b.getAttribute('data-t') });
              b.textContent = T('added');
              setTimeout(function () { location.reload(); }, 600);
            }).catch(function () { b.disabled = false; b.textContent = T('add'); });
        });
      });
    });
  }

  /* ---------- Klaviyo client subscribe (double opt-in) ---------- */
  function klaviyoSubscribe(email, props) {
    var profileAttr = { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
    if (props) { profileAttr.properties = props; }
    var payload = { data: { type: 'subscription', attributes: { custom_source: (props && props.christina_quiz_line ? 'Quiz dopasowania' : 'Onsite Exit Popup'), profile: { data: { type: 'profile', attributes: profileAttr } } }, relationships: { list: { data: { type: 'list', id: CFG.klaviyoList } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + CFG.klaviyoCompany, { method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2025-07-15' }, body: JSON.stringify(payload) });
  }

  /* ==================================================================
     R7Z2 — WSPÓLNA OBSŁUGA DIALOGU MODALNEGO
     ================================================================== */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function openDialog(ov, pop, titleId, onClose) {
    var prevFocus = document.activeElement;
    var closed = false;

    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-labelledby', titleId);
    pop.setAttribute('tabindex', '-1');
    document.body.appendChild(ov);

    var sbw = window.innerWidth - document.documentElement.clientWidth;
    var prevOverflow = document.body.style.overflow;
    var prevPadRight = document.body.style.paddingRight;
    document.body.style.overflow = 'hidden';
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';

    function focusables() {
      return Array.prototype.filter.call(pop.querySelectorAll(FOCUSABLE), function (el) {
        return !el.hasAttribute('hidden') && el.getClientRects().length > 0;
      });
    }
    function onKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close('esc'); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) { e.preventDefault(); pop.focus(); return; }
      var first = f[0], last = f[f.length - 1], inside = pop.contains(document.activeElement);
      if (e.shiftKey) {
        if (!inside || document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (!inside || document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    document.addEventListener('keydown', onKey, true);

    function close(reason) {
      if (closed) return;
      closed = true;
      if (activeYield === yieldNow) activeYield = null;
      stopBlockers();
      document.removeEventListener('keydown', onKey, true);
      document.body.style.overflow = prevOverflow;
      document.body.style.paddingRight = prevPadRight;
      ov.classList.remove('cco-show');
      if (onClose) { try { onClose(reason); } catch (e) {} }
      if (prevFocus && prevFocus.isConnected && typeof prevFocus.focus === 'function') {
        try { prevFocus.focus({ preventScroll: true }); } catch (e) { try { prevFocus.focus(); } catch (e2) {} }
      }
      setTimeout(function () { if (ov.parentNode) ov.parentNode.removeChild(ov); }, 350);
    }

    /* P0-1 — natychmiastowe ustąpienie pola modalowi zakupowemu.
       Kolejność ma znaczenie: najpierw zdejmujemy pointer-events (atrybut),
       dopiero potem zamykamy, żeby ani jedna klatka nie przechwyciła dotyku. */
    function yieldNow() {
      ov.setAttribute('data-cco-yield', '');
      close('blocked');
    }
    activeYield = yieldNow;
    watchBlockers();

    requestAnimationFrame(function () {
      ov.classList.add('cco-show');
      var f = focusables();
      (f[0] || pop).focus();
    });

    return close;
  }

  function validateForm(pop, emailEl, consentEl, errEl) {
    var email = (emailEl.value || '').trim();
    emailEl.classList.remove('cco-pop__in--err');
    emailEl.removeAttribute('aria-invalid');
    errEl.textContent = '';
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      emailEl.classList.add('cco-pop__in--err');
      emailEl.setAttribute('aria-invalid', 'true');
      errEl.textContent = T('errEmail');
      emailEl.focus();
      return null;
    }
    if (!consentEl.checked) {
      errEl.textContent = T('errConsent');
      consentEl.focus();
      return null;
    }
    return email;
  }

  /* ---------- S1/S5 exit-intent popup (NIE na stronie głównej) ---------- */
  var popShown = false, popDone = (ls('cco_pop_done') === '1');
  function canShowPop() {
    if (popShown || popDone) return false;
    if (CFG.pageType === 'index') return false;
    if (CFG.pageType === 'cart' || CFG.pageType === 'checkout' || CFG.pageType === 'password') return false;
    if (/\/checkout|\/account/.test(CFG.path)) return false;
    if (CFG.path.indexOf('/quiz') > -1) return false;
    if (!CFG.isPro && CFG.acceptsMarketing) return false;
    if (CFG.isPro && CFG.path.indexOf('prowadze-salon') > -1) return false;
    var seen = ls('cco_pop_seen'); if (seen && (Date.now() - (+seen)) < 7 * DAY) return false;
    return true;
  }

  function buildPop() {
    var TITLE_ID = 'cco-pop-title';
    var ov = document.createElement('div'); ov.className = 'cco-ov';
    var inner;
    if (CFG.isPro) {
      inner = '<button type="button" class="cco-pop__x" aria-label="' + T('closeAria') + '">&times;</button>'
        + '<p class="cco-pop__eyebrow">' + T('proEyebrow') + '</p>'
        + '<h2 class="cco-pop__h" id="' + TITLE_ID + '">' + T('proH') + '</h2>'
        + '<p class="cco-pop__p">' + T('proP') + '</p>'
        + '<div class="cco-b2b__li">' + T('proLi1') + '</div>'
        + '<div class="cco-b2b__li">' + T('proLi2') + '</div>'
        + '<div class="cco-b2b__li">' + T('proLi3') + '</div>'
        + '<a class="cco-btn" id="cco-b2b-cta" href="' + CFG.proUrl + '">' + T('proCta') + '</a>';
    } else {
      inner = '<button type="button" class="cco-pop__x" aria-label="' + T('closeAria') + '">&times;</button>'
        + '<div class="cco-pop__body">'
        + '<p class="cco-pop__eyebrow">' + T('nlEyebrow') + '</p>'
        + '<h2 class="cco-pop__h" id="' + TITLE_ID + '">' + T('nlH') + '</h2>'
        + '<p class="cco-pop__p">' + T('nlP') + '</p>'
        + '<input type="email" class="cco-pop__in" id="cco-email" placeholder="' + T('emailPh') + '" aria-label="' + T('emailAria') + '" autocomplete="email">'
        + '<p class="cco-pop__err" id="cco-err" role="alert"></p>'
        + '<div class="cco-pop__consent"><input type="checkbox" id="cco-consent"><label for="cco-consent">' + T('nlConsent') + '</label></div>'
        + '<button type="button" class="cco-btn" id="cco-sub">' + T('nlBtn') + '</button>'
        + '<a class="cco-pop__alt" href="' + CFG.quizUrl + '">' + T('nlAlt') + '</a>'
        + '<p class="cco-pop__note">' + T('nlNote') + '</p>'
        + '</div>';
    }
    var pop = document.createElement('div'); pop.className = 'cco-pop'; pop.innerHTML = inner; ov.appendChild(pop);

    var close = openDialog(ov, pop, TITLE_ID, function (reason) {
      dl('cca_popup_close', { popup_id: CFG.isPro ? 'exit_b2b' : 'exit_newsletter', reason: reason || 'x' });
    });

    ov.querySelector('.cco-pop__x').addEventListener('click', function () { close('x'); });
    ov.addEventListener('click', function (e) { if (e.target === ov) close('overlay'); });

    if (CFG.isPro) {
      ov.querySelector('#cco-b2b-cta').addEventListener('click', function () {
        dl('cca_popup_click', { popup_id: 'exit_b2b', variant: 'b2b', cta_label: T('proCta') });
        dl('cca_lead_b2b_submit', { business_type: 'unknown', source: 'exit_popup' });
        lset('cco_pop_done', '1');
      });
    } else {
      var btn = ov.querySelector('#cco-sub');
      btn.addEventListener('click', function () {
        var emailEl = ov.querySelector('#cco-email');
        var consentEl = ov.querySelector('#cco-consent');
        var errEl = ov.querySelector('#cco-err');
        var email = validateForm(pop, emailEl, consentEl, errEl);
        if (!email) return;
        btn.disabled = true; btn.textContent = T('saving');
        dl('cca_popup_click', { popup_id: 'exit_newsletter', cta_label: T('nlBtn') });
        klaviyoSubscribe(email, null)
          .then(function (r) {
            if (r.status >= 200 && r.status < 300) {
              lset('cco_pop_done', '1');
              dl('cca_popup_submit', { popup_id: 'exit_newsletter', list_id: CFG.klaviyoList, consent: true });
              dl('sign_up', { method: 'onsite_popup' });
              ov.querySelector('.cco-pop__body').innerHTML = '<p class="cco-pop__eyebrow">' + T('thanksEyebrow') + '</p><h2 class="cco-pop__h" id="' + TITLE_ID + '">' + T('thanksH') + '</h2><p class="cco-pop__ok">' + T('nlOk') + '</p>';
              ov.querySelector('.cco-pop__x').focus();
              setTimeout(function () { close('success'); }, 4500);
            } else { btn.disabled = false; btn.textContent = T('tryAgain'); }
          }).catch(function () { btn.disabled = false; btn.textContent = T('tryAgain'); });
      });
    }
    return ov;
  }

  function showPop() {
    if (!canShowPop()) return;
    /* P0-1 — nigdy nad modalem zakupowym. */
    if (blockersOpen()) return;
    popShown = true; lset('cco_pop_seen', Date.now());
    buildPop();
    dl('cca_popup_view', { popup_id: CFG.isPro ? 'exit_b2b' : 'exit_newsletter', variant: CFG.isPro ? 'b2b' : 'b2c', segment: CFG.isPro ? 'b2b' : 'b2c' });
  }

  /* R7-A3 — WYZWALACZE. ZERO MANIPULACJI HISTORIĄ PRZEGLĄDARKI.
       1) zamiar wyjścia kursorem przez GÓRNĄ krawędź (tylko pointer: fine),
       2) brak aktywności >= 45 s,
       3) dojście do 90 % dokumentu — R8: IntersectionObserver, nie `scroll`.
     Częstotliwość: maks. RAZ NA 7 DNI (canShowPop -> `cco_pop_seen`). */
  var sentinelIO = null, sentinel = null;
  function armScrollDepth() {
    if (!('IntersectionObserver' in window)) return;   /* brak IO -> brak tego wyzwalacza */
    sentinel = document.createElement('div');
    sentinel.className = 'cco-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    document.body.appendChild(sentinel);

    function observe() {
      if (sentinelIO) sentinelIO.disconnect();
      var doc = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
      var view = window.innerHeight || document.documentElement.clientHeight;
      if (doc - view < 200) return;   /* strona bez przewijania — brak sygnału */
      /* Dolny margines = 10 % dokumentu: wartownik (koniec treści) wchodzi w pole
         obserwacji dokładnie przy (scrollY + view) / doc >= 0,9. */
      var margin = Math.round(doc * 0.1);
      sentinelIO = new IntersectionObserver(function (recs) {
        for (var i = 0; i < recs.length; i++) {
          if (!recs[i].isIntersecting) continue;
          sentinelIO.disconnect(); sentinelIO = null;
          showPop();
          return;
        }
      }, { rootMargin: '0px 0px ' + margin + 'px 0px' });
      sentinelIO.observe(sentinel);
    }
    observe();
    var rt = null;
    window.addEventListener('resize', function () {
      if (popShown || popDone) return;
      if (rt) clearTimeout(rt);
      rt = setTimeout(observe, 250);
    }, { passive: true });
  }

  function armTriggers() {
    if (!canShowPop()) return;   /* nic nie pokażemy — nie zakładamy nasłuchów */

    /* 1. Zamiar opuszczenia kursorem (desktop). */
    var precyzyjny = false;
    try { precyzyjny = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches); } catch (e) {}
    if (precyzyjny) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 8) showPop();
      });
    }

    /* 2. Brak aktywności >= 45 s. */
    var bezczynnosc = null;
    function przeladujBezczynnosc() {
      if (popShown || popDone) return;
      if (bezczynnosc) clearTimeout(bezczynnosc);
      bezczynnosc = setTimeout(function () { if (!document.hidden) showPop(); }, 45000);
    }
    ['pointerdown', 'pointermove', 'keydown', 'wheel', 'touchstart', 'scroll'].forEach(function (ev) {
      window.addEventListener(ev, przeladujBezczynnosc, { passive: true });
    });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) przeladujBezczynnosc(); });
    przeladujBezczynnosc();

    /* 3. Głębokość przewinięcia — bez nasłuchu `scroll`. */
    armScrollDepth();
  }

  /* ---------- Q: quiz connect ---------- */
  var SKIN_TOKENS = ['dry', 'oily', 'sensitive', 'normal', 'combination', 'mature', 'dehydrated', 'sucha', 'tlusta', 'mieszana', 'wrazliwa', 'normalna', 'dojrzala'];
  var CONCERN_TOKENS = ['acne', 'pigmentation', 'redness', 'wrinkles', 'eyes', 'dullness', 'rosacea', 'hydration', 'tradzik', 'przebarwienia', 'zaczerwienienia', 'zmarszczki', 'cienie', 'blask'];
  function quizProfileFromLS() {
    try {
      var r = JSON.parse(ls('christina-quiz-result') || 'null'); if (!r) return null;
      var ans = r.answers || {}; var vals = [];
      Object.keys(ans).forEach(function (k) { var v = ans[k]; if (Array.isArray(v)) vals = vals.concat(v); else vals.push(v); });
      vals = vals.map(function (x) { return String(x).toLowerCase(); });
      var skin = vals.filter(function (v) { return SKIN_TOKENS.indexOf(v) > -1; })[0] || null;
      var concern = vals.filter(function (v) { return CONCERN_TOKENS.indexOf(v) > -1; })[0] || null;
      return { line: r.key || null, skin: skin, concern: concern };
    } catch (e) { return null; }
  }

  function showQuizCapture(prof) {
    if (ls('cco_quiz_done') === '1') return;
    if (CFG.acceptsMarketing) return;
    if (blockersOpen()) return;   /* P0-1 */
    var TITLE_ID = 'ccoq-pop-title';
    var line = (prof && prof.line) || '';
    var ov = document.createElement('div'); ov.className = 'cco-ov';
    var pop = document.createElement('div'); pop.className = 'cco-pop';
    pop.innerHTML = '<button type="button" class="cco-pop__x" aria-label="' + T('closeAria') + '">&times;</button>'
      + '<div class="cco-pop__body">'
      + '<p class="cco-pop__eyebrow">' + T('qEyebrow') + '</p>'
      + '<h2 class="cco-pop__h" id="' + TITLE_ID + '">' + T('qH') + '</h2>'
      + '<p class="cco-pop__p">' + T('qP') + '</p>'
      + '<input type="email" class="cco-pop__in" id="ccoq-email" placeholder="' + T('emailPh') + '" aria-label="' + T('emailAria') + '" autocomplete="email">'
      + '<p class="cco-pop__err" id="ccoq-err" role="alert"></p>'
      + '<div class="cco-pop__consent"><input type="checkbox" id="ccoq-consent"><label for="ccoq-consent">' + T('qConsent') + '</label></div>'
      + '<button type="button" class="cco-btn" id="ccoq-sub">' + T('qBtn') + '</button>'
      + '<p class="cco-pop__note">' + T('nlNote') + '</p>'
      + '</div>';
    ov.appendChild(pop);

    var close = openDialog(ov, pop, TITLE_ID, function (reason) {
      dl('cca_popup_close', { popup_id: 'quiz_capture', reason: reason || 'x' });
    });
    dl('cca_popup_view', { popup_id: 'quiz_capture', variant: 'quiz', segment: 'b2c', matched_line: line });

    pop.querySelector('.cco-pop__x').addEventListener('click', function () { close('x'); });
    ov.addEventListener('click', function (e) { if (e.target === ov) close('overlay'); });

    var btn = pop.querySelector('#ccoq-sub');
    btn.addEventListener('click', function () {
      var emailEl = pop.querySelector('#ccoq-email');
      var consentEl = pop.querySelector('#ccoq-consent');
      var errEl = pop.querySelector('#ccoq-err');
      var email = validateForm(pop, emailEl, consentEl, errEl);
      if (!email) return;
      btn.disabled = true; btn.textContent = T('qSending');
      dl('cca_popup_click', { popup_id: 'quiz_capture', cta_label: T('qBtn') });
      var props = { christina_quiz_completed: true, christina_quiz_line: line, christina_quiz_date: new Date().toISOString() };
      if (prof && prof.skin) props.christina_skin_type = prof.skin;
      if (prof && prof.concern) props.christina_concern = prof.concern;
      klaviyoSubscribe(email, props)
        .then(function (r) {
          if (r.status >= 200 && r.status < 300) {
            lset('cco_quiz_done', '1'); lset('cco_pop_done', '1');
            dl('cca_popup_submit', { popup_id: 'quiz_capture', list_id: CFG.klaviyoList, consent: true, matched_line: line });
            dl('sign_up', { method: 'quiz' });
            pop.querySelector('.cco-pop__body').innerHTML = '<p class="cco-pop__eyebrow">' + T('thanksEyebrow') + '</p><h2 class="cco-pop__h" id="' + TITLE_ID + '">' + T('thanksH') + '</h2><p class="cco-pop__ok">' + T('qOk') + '</p>';
            pop.querySelector('.cco-pop__x').focus();
            setTimeout(function () { close('success'); }, 5000);
          } else { btn.disabled = false; btn.textContent = T('tryAgain'); }
        }).catch(function () { btn.disabled = false; btn.textContent = T('tryAgain'); });
    });
  }

  function quizConnect() {
    function bridge(csqName, ccaName, extra) {
      window.addEventListener(csqName, function (e) { var p = Object.assign({}, (e && e.detail) || {}); if (extra) for (var k in extra) p[k] = extra[k]; dl(ccaName, p); });
    }
    bridge('csq:start', 'cca_quiz_start');
    bridge('csq:step_view', 'cca_quiz_step_view');
    bridge('csq:step_complete', 'cca_quiz_step_complete');
    bridge('csq:cta_click', 'cca_recommendation_click', { cca_source: 'quiz' });
    window.addEventListener('csq:complete', function (e) {
      var prof = quizProfileFromLS(); var d = (e && e.detail) || {};
      dl('cca_quiz_complete', { matched_line: (prof && prof.line) || d.key || '', skin_type: (prof && prof.skin) || '', concern: (prof && prof.concern) || '' });
      setTimeout(function () { showQuizCapture(prof); }, 1400);
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    if (CFG.pageType === 'cart') {
      refreshCart().then(function () { cartEnhance(document); });
      document.addEventListener('cart:updated', function () { refreshCart().then(function () { cartEnhance(document); }); });
    }
    quizConnect();
    setTimeout(armTriggers, 1500);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
